import { render, staticRenderFns } from "./adminClass.vue?vue&type=template&id=67d13d97&scoped=true"
import script from "./adminClass.vue?vue&type=script&lang=ts"
export * from "./adminClass.vue?vue&type=script&lang=ts"
import style0 from "./adminClass.vue?vue&type=style&index=0&id=67d13d97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d13d97",
  null
  
)

export default component.exports